import Vue from 'vue';
export default Vue.extend({
    props: {
        checkBalanceInfo: {
            type: Object,
            required: true,
        },
    },
    data: function () {
        return {
            checkConfirm: [
                [
                    {
                        span: 12,
                        label: '开票渠道',
                        value: '',
                    },
                    {
                        span: 12,
                        label: '账单截止日期',
                        value: '',
                    },
                ],
                [
                    {
                        span: 8,
                        label: '本期条目',
                        value: '',
                    },
                    {
                        span: 8,
                        label: '总保费',
                        value: '',
                    },
                    {
                        span: 8,
                        label: '推广费',
                        value: '',
                    },
                ],
            ],
        };
    },
    methods: {
        closeSelf: function () {
            this.$emit('shut');
        },
        doLaunchBalance: function () {
            var _this = this;
            this.launchBalanceSettle(this.checkBalanceInfo.statementId).then(function (res) {
                _this.closeSelf();
                if (res) {
                    _this.$message({
                        message: '生成结算单成功',
                        type: 'success',
                    });
                    _this.openSettleDetailPage(res.data.id);
                }
            });
        },
        launchBalanceSettle: function (statementId) {
            var params = {
                statementId: statementId,
            };
            return this.$request({
                url: '/proxy/carInsurance/channelBill/createSettlement',
                method: 'post',
                data: params,
            }).then(function (res) {
                if (!res) {
                    return;
                }
                if (res.errorCode) {
                    return;
                }
                return res;
            });
        },
        openSettleDetailPage: function (settlementId) {
            this.$router.push({
                name: 'insBalanceSettleDetail',
                params: { settleOrderId: settlementId.toString() },
            });
        },
    },
    created: function () {
        this.checkConfirm[0][0].value = this.checkBalanceInfo.channelName;
        this.checkConfirm[0][1].value = this.checkBalanceInfo.endTime;
        this.checkConfirm[1][0].value = this.checkBalanceInfo.sumBillNumber;
        this.checkConfirm[1][1].value = this.checkBalanceInfo.sumOrderAmount;
        this.checkConfirm[1][2].value = this.checkBalanceInfo.sumAmount;
    },
});
